








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CalendarHeader extends Vue {
  @Prop({ type: Array, default: () => [] })
  readonly days!: Array<string>;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/remote-edu/calendar/components/calendar/components/calendarheader/CalendarHeader.vue